var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPlay = function SvgPlay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11,
    height: 14,
    fill: "currentColor",
    style: {
      color: "#fff"
    }
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M1.36.44A.665.665 0 0 0 .335 1v12a.665.665 0 0 0 1.025.56l9.333-6a.665.665 0 0 0 0-1.12L1.36.44ZM9.104 7l-7.439 4.782V2.218L9.104 7Z",
    clipRule: "evenodd"
  })));
};
export default SvgPlay;